/**
 * @desc undefined
 */
import { BankEntity } from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBankParameter = {
  id?: string
}

const method = 'GET'
const url = '/finance/bank'

export const queryBankApi = (
  params?: QueryBankParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BankEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryBankApi.method = method
queryBankApi.url = url
